import Bowser from 'bowser';

// Detect Safari browser (including iOS Safari).
export const getIsSafari = (): boolean => {
  if (typeof window === 'undefined') return false;
  const browser = Bowser.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowserName();
  return browserName === 'Safari';
};
